import { useQuery } from '../use-query';
import { saleService } from '../../../services';
import { FILTERS_TYPES } from '../../../design-system';
import { BelongsTo, OfferStatus, User } from '../../../types';
import { extendContainerValidator } from '../../../utils';

interface UseSalesByClientQueryProps {
  [key: string]: any;
}

export const useSalesByClientQuery = (keys: UseSalesByClientQueryProps) => {
  if (keys.number?.length < 3 || !extendContainerValidator(keys.number)) delete keys.number;
  const isYard = window.location.pathname.includes('/marketplace/yards');

  return useQuery(
    ['sales', 'by-client', JSON.stringify(keys)],
    () => {
      return saleService
        .getAllByClientYard({
          params: keys,
          path: isYard ? 'yard' : 'client',
        })
        .then((res) => res.data);
    },
    {
      initialData: { data: [], totalCount: 0 },
      keepPreviousData: true,
    },
  );
};

interface UseSalesQueryProps {
  user: User;
  filtersType?: (typeof FILTERS_TYPES)[number];
  [key: string]: any;
}

export const useSalesQuery = ({ user, filtersType, ...keys }: UseSalesQueryProps) => {
  if (
    typeof keys.number === 'string' &&
    (keys.number?.length < 3 || !extendContainerValidator(keys.number))
  )
    delete keys.number;
  if (Array.isArray(keys.number)) {
    delete keys.take;
    delete keys.skip;
  }

  if (filtersType === 'marketplace') {
    if (user.belongsTo === BelongsTo.CLIENT) {
      delete keys.clientId;
    }
    if (user.belongsTo === BelongsTo.YARD) {
      delete keys.yardId;
    }
    if (user.belongsTo === BelongsTo.YARD_COMPANY) {
      delete keys.yardCompanyId;
      delete keys.country;
      delete keys.city;
    }
  }

  return useQuery(
    ['sales', JSON.stringify(keys)],
    () => {
      return saleService
        .getAll({
          params: keys,
        })
        .then((res) => {
          res.data.data = res.data.data.map((item) => {
            if (item.offer && item.offer.some((obj) => obj.status === OfferStatus.SOLD_INST)) {
              item.sale.status = OfferStatus.SOLD_INST;
            }

            return item;
          });

          return res.data;
        });
    },
    { initialData: { data: [], totalCount: 0 }, keepPreviousData: true },
  );
};

export const useSaleStatsQuery = () => {
  return useQuery(
    ['sales', 'stats'],
    () => {
      return saleService.getAllStats().then((res) => res.data);
    },
    { initialData: { data: [], totalCount: 0 }, keepPreviousData: true },
  );
};
